import React, { Component } from 'react'
import {
    Icon,
    Breadcrumb as StixBreadcrumb,
} from '@softwaredev_cegeka/stix-core'
import { Link } from 'react-router-dom'
import { reverse } from 'src/routes/config'

class Breadcrumb extends Component {
    render() {
        const {
            match: { params },
            breadcrumbs,
        } = this.props
        let items = []
        if (breadcrumbs instanceof Function) {
            items = breadcrumbs(params)
        } else if (Array.isArray(breadcrumbs)) {
            items = breadcrumbs
        }
        return (
            <StixBreadcrumb customSeparator>
                <StixBreadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    <Icon icon="home" />
                </StixBreadcrumb.Item>
                {items.map((item, index) =>
                    item.linkName ? (
                        <StixBreadcrumb.Item
                            active={index === items.length - 1}
                            key={index}
                            linkAs={Link}
                            linkProps={{ to: reverse(item.linkName, params) }}
                        >
                            {item.label}
                        </StixBreadcrumb.Item>
                    ) : (
                        <StixBreadcrumb.Item
                            active={index === items.length - 1}
                            key={index}
                        >
                            {item.label}
                        </StixBreadcrumb.Item>
                    )
                )}
            </StixBreadcrumb>
        )
    }
}

export default Breadcrumb
